$(document).ready(function(){
   $(document).on('click', '[data-calendar-preselect]', function(e){
      e.preventDefault();
      var _val = $(this).attr('data-calendar-preselect');

      $(this).parent().parent().find('.input-group .form-control, input[type="hidden"]').each(function(){
         $(this).val(_val);
      });

      if ($(this).text() === 'Morgen') {
         localStorage.setItem('tomorrowButton', '1');
      } else {
         localStorage.setItem('todayButton', '1');
      }

      $(this).closest('form').submit();
   });

   $(document).on('click', '.mobile-button .button, .close-search', function(e){
      e.preventDefault();
      $('body').toggleClass('no-scroll');
      $('.filter').toggleClass('hidden-xs hidden-sm fixed');
   });

   $(document).on('click', '.mobile-button .button.close-filter', function(e){
      e.preventDefault();
      $(this).find('span.show-count').remove().removeClass('close-filter');
   });

    $(document).on('click', '.nav-cinemagic [data-toggle="filter"]', function(e){
      e.preventDefault();
      $('body').toggleClass('no-scroll');
      $('.cinemagic-filter.filter').toggleClass('fixed');
   });

   if (typeof(Storage) !== "undefined") {
      var _sidebarStates = localStorage.getItem('sidebarStates'),
          _sidebarState = {};

      if (_sidebarStates) {
         _sidebarState = JSON.parse(_sidebarStates);
      }

      $.each(_sidebarState, function(k,v) {
         var _elem = $('[data-target="'+ k +'"]');

         if (v === 'false') {
            _elem.attr('aria-expanded', 'false');
            $(k).removeClass('in');
         }
      });
   }

   $(document).on('click', 'aside [data-toggle]', function(){
      _sidebarState[$(this).data('target')] = $(this).attr('aria-expanded');

      if (typeof(Storage) !== "undefined") {
         localStorage.setItem('sidebarStates', JSON.stringify(_sidebarState));
      }
   });
});

$(window).resize(function () {
   if (!$('.mobile-button').is(':visible') && $('body').hasClass('no-scroll')) {
      $('body').toggleClass('no-scroll');
      $('.filter:not(.cinemagic-filter)').toggleClass('hidden-xs hidden-sm fixed');
   }
});
